import React from 'react';
import PropTypes from 'prop-types';

const Optional = ({ fill = '' }) => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M2 3.25197C2 2.56052 2.56053 2 3.25197 2H10.0912V3.37008H3.37008V12.6299H12.6299V7.4278H14V12.748C14 13.4395 13.4395 14 12.748 14H3.25197C2.56053 14 2 13.4395 2 12.748V3.25197Z"
      fill={fill || 'var(--SECONDARY_LIGHT)'}
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M13.9913 4.26957L7.29433 10.9666L4.38867 8.06091L5.35746 7.09212L7.29433 9.02898L13.0225 3.30078L13.9913 4.26957Z"
      fill={fill || 'var(--SECONDARY_LIGHT)'}
    />
  </svg>
);

Optional.propTypes = {
  fill: PropTypes.string,
};

export default Optional;
